// Mock data for RHE Project Consulting website

export const clientLogos = [
  { id: "tfnsw", name: "Transport for NSW", logo: "https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/re4il8zm_Transport%20for%20NSW%20logo%20close-up.png", large: true },
  { id: "byron", name: "Byron Shire Council", logo: "https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/ucrdd1cv_BSC_LOGO_SECONDARY_TEAL.jpg" },
  { id: "newcastle", name: "City of Newcastle", logo: "https://newcastle.nsw.gov.au/getmedia/e55f0c2a-9fd1-4c57-9eb1-7c465b921c73/City_of_Newcastle_Horizontal_RGB.svg", large: true },
  { id: "midcoast", name: "MidCoast Council", logo: "https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/6r45iess_MCC.svg" },
  { id: "nswra", name: "NSW Reconstruction Authority", logo: "https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/v0tyl6je_NSW%20Reconstruction%20Authority%20logo.png", large: true }
];

export const differentiators = [
  {
    id: "nsw-experience",
    title: "Extensive NSW Government Experience",
    description: "Proven track record delivering infrastructure programs for NSW government agencies and councils across the state."
  },
  {
    id: "drfa",
    title: "DRFA Expertise",
    description: "Extensive experience managing Disaster Recovery Funding Arrangements projects and complex funding compliance."
  },
  {
    id: "multi-stakeholder",
    title: "Multi-Stakeholder Coordination",
    description: "Skilled at managing complex projects involving multiple government agencies, utilities, and community stakeholders."
  },
  {
    id: "design-delivery",
    title: "Design to Delivery Support",
    description: "End-to-end capability from concept design through procurement to construction delivery and project closeout."
  },
  {
    id: "practical",
    title: "Practical Delivery Focus",
    description: "Real-world construction and client-side experience ensures pragmatic, delivery-focused project solutions."
  },
  {
    id: "buynsw",
    title: "BuyNSW",
    description: "RHE holds pre-qualification as a \"Certified Consultant\" under the NSW Government's Consultants in Construction Scheme SCM 1191, allowing for simple and easy engagement for local and state Government agencies."
  }
];

export const capabilities = [
  {
    id: "planning",
    title: "Project Planning & Delivery Strategy",
    description: "Development of project delivery frameworks, procurement strategies, and program management plans for major infrastructure works."
  },
  {
    id: "procurement",
    title: "Consultant & Contractor Procurement",
    description: "Management of competitive tender processes for professional services and construction contracts ensuring value for money."
  },
  {
    id: "costing",
    title: "Concept Cost Estimating & Budgeting",
    description: "Preliminary cost estimation and budget development to support funding applications and project approvals."
  },
  {
    id: "grants",
    title: "Grant Applications & Funding Support",
    description: "Preparation of funding submissions and management of grant requirements including DRFA and other government programs."
  },
  {
    id: "design",
    title: "Design Management",
    description: "Coordination of consultant design teams, design reviews, and stakeholder approvals through all project phases."
  },
  {
    id: "construction",
    title: "Construction Delivery Support",
    description: "Client-side project management during construction including contract administration, progress monitoring, and quality assurance."
  },
  {
    id: "stakeholder",
    title: "Stakeholder Management & Reporting",
    description: "Comprehensive stakeholder engagement and regular project reporting to councils, agencies, and funding bodies."
  }
];

export const projects = [
  {
    id: "mitchell-seawall",
    title: "Mitchell Street Seawall Upgrade",
    value: "$5.1M",
    description: "Coastal protection infrastructure upgrade restoring the structural integrity of the Stockton Beach seawall.",
    image: "https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/3868qjt0_seawall.jpg",
    modalImage: "https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/9yxkblfs_mssu.jpg",
    detailedDescription: "The Mitchell Street Sea Wall spans approximately 600m along the coastal frontage of Stockton Beach in NSW. Due to deterioration of the early 1990's structure, a renewal and upgrade project is required in order to restore the seawall to its appropriate design standards, ensure the durability of the structure and safeguard the coastal protection function going forward. The solution to achieve the project objectives is to infill with 8,500+ tonnes of similarly sized rock armour to a create hydraulically stable profile. RHE are providing PM support for the City of Newcastle including finalisation of the design, assistance in DRF Round 3 grant submission, tendering of the project, project award and management of the principle contractor. Approx Project value – $5.1M"
  },
  {
    id: "western-corridor",
    title: "Western Corridor Road Upgrades",
    value: "$38M",
    description: "Major road infrastructure upgrade involving utility relocations and multi-stakeholder coordination.",
    image: "https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/1w7vj5hf_Longworth%20Ave.png",
    modalImage: "https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/jfoaervo_TC_00370%20v2.JPG",
    detailedDescription: "The Western corridor upgrades project is a significant road upgrade on Longworth Avenue and Minmi Road in Wallsend. The project creates two lanes of traffic in each direction to reduce traffic congestion and bottlenecks. Requiring the relocation of critical existing utilities, the project involves multiple stakeholders and careful sequencing. Whilst undertaking a PM support role for CN, the scope of work for RHE Project Consulting includes management of the principle contractor on-site, monitoring quality and managing project issues. Approx value - $38M"
  },
  {
    id: "astra-landfill",
    title: "Astra Street Landfill Remediation",
    value: "$46M",
    description: "Environmental remediation and landfill capping project adjacent to nationally significant wetlands.",
    image: "https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/wscyhh7l_astra%20cover.jpg",
    modalImage: "https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/vje303dg_astra%202.jpg",
    detailedDescription: "The Astra street project includes the remediation and capping of the former Astra Street Landfill at 2 Astra Street, Shortland and subsequently preparing the 44Ha site for open space use. This was a complex and large scale environmental and civil project requiring the capping of a former landfill with approximately 260,000m3 of capping and cover materials adjacent to national significant and RAMSAR listed wetlands. The planning phase included management of the asbestos contaminated site cover soils and waste materials. The project has required continued co-ordination with the EPA. Whilst undertaking a PM support role for CN, the scope of work for RHE Project Consulting has included management of the design consultant (ARUP) to complete the detailed design, tendering of the project, project award and management of the principle contractor. Approx Value $46M"
  },
  {
    id: "organics-facility",
    title: "Organics Processing Facility",
    value: "$35.6M",
    description: "Development of a major food and garden organics processing facility for municipal waste management.",
    image: "https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/7q8lcsfi_Screenshot%202023-04-17%20145335.png",
    modalImage: "https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/dubyke32_OPF%202.jpg",
    detailedDescription: "The City of Newcastle investigated the option to construct an Organics Processing Facility for combined Food Organics and Garden Organics (FOGO) at SWMC. The facility was being designed to process 50,000 tonnes per annum. The project involved preparation of an Environmental Impact Statement and completion of design, with construction and commissioning subject to final business case approval. Whilst undertaking a PM support role for CN, the scope of works for RHE Project consulting included tendering of the project, project award and the ongoing management of the principle contractor who was responsible for design phase. The contract was awarded using a AS4916 Construction Management agreement."
  },
  {
    id: "cell9",
    title: "Cell 9 Stage 2",
    value: "$24M",
    description: "Large scale landfill infrastructure expansion including excavation and installation of synthetic liner systems.",
    image: "https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/cpnoqsti_Cell%209%20finish.jpg",
    modalImage: "https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/3b7rtmdn_IMG_2975.jpeg",
    detailedDescription: "Cell 9 was a large scale civil project where the objective was to create approximately 3 million cubic metres of landfill void space for the continued expansion of the Summerhill Waste Management Centre (SWMC). The construction involved the excavation of 700,000 m3 of material and installation of an 81,000 m2 synthetic leachate barrier system in accordance with the Environment Protection Authority (EPA) 2016 landfill Guidelines. Whilst undertaking a PM support role for CN, the scope of work for RHE Project Consulting included management of the design consultant (GHD) to complete the detailed design, tendering of the project, project award and management of the principle contractor. Approx value - $24M"
  },
  {
    id: "disaster-recovery",
    title: "Natural Disaster Recovery Programs",
    value: "",
    description: "Regional engagement with local councils for disaster recovery arrangements under the NSW Disaster Assistance Guidelines.",
    image: "https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/dmih1nzg_EW.png",
    modalImage: "https://customer-assets.emergentagent.com/job_rhe-infrastructure/artifacts/qaxhsyre_ND%20modal.jpg",
    detailedDescription: "RHE Project Consulting have provided Transport for NSW (TfNSW) with project management/technical support, specifically in relation to the management of the natural disasters grant funding programs. This required close co-ordination and involvement with over 13 councils across the Hunter New England regions of NSW for in excess of 450 sites across several declared natural disaster events between 2020 to 2022. The services were completed in October 2025."
  }
];

export const teamMembers = [
  {
    id: "andrew-ball",
    name: "Andrew Ball",
    title: "Senior Project Manager",
    experience: "20+ years delivering major infrastructure projects including civil, healthcare, commercial and data centres."
  },
  {
    id: "jayantha",
    name: "Jayantha Jayaweera",
    title: "Senior Project Manager / Civil Engineer",
    experience: "40+ years experience in civil construction and infrastructure delivery."
  },
  {
    id: "brian",
    name: "Brian Jacobs",
    title: "Senior Project Manager / Civil Engineer",
    experience: "30+ years experience delivering civil infrastructure projects."
  },
  {
    id: "shane",
    name: "Shane Booby",
    title: "Senior Project Manager / Civil Engineer",
    experience: "25+ years experience managing road and infrastructure projects."
  },
  {
    id: "david",
    name: "David Taylor",
    title: "Civil Engineer",
    experience: "10+ years experience supporting disaster recovery infrastructure programs."
  },
  {
    id: "mitchell",
    name: "Mitchell Troke",
    title: "Senior Project Manager / Civil Engineer",
    experience: "20 years experience across contractor and client-side project delivery roles."
  }
];

export const serviceRegions = [
  "Hunter",
  "Central Coast",
  "MidCoast",
  "Newcastle"
];
